export const CHART_PADDINGS = 30;
export const AMBER_CLASS_NAME = 'var-limits-amber';
export const AMBER_MIN_THRESHOLD = 3;
export const AMBER_MAX_THRESHOLD = 4;
export const RED_CLASS_NAME = 'var-limits-red';
export const RED_MIN_THRESHOLD = 5;
